import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import Tooltip from '@material-ui/core/Tooltip';
import Fab from '@material-ui/core/Fab';
import Cookies from 'js-cookie';


export class Layout extends Component {
    static displayName = Layout.name;

    goBack() {
        if (
            window.location.pathname.toLowerCase().startsWith('/display')) {
            return;
        }

        window.history.go(-1);
    }

    render() {
        return (
            <div>
                <NavMenu />
                <Container>
                    {this.props.children}

                    {
                        window.location.pathname.toLowerCase().startsWith('/display') ||
                        window.location.pathname.toLowerCase().startsWith('/showcase')
                        ? (<div></div>) : (
                        <Tooltip title="뒤로가기" aria-label="add">
                            <Fab color="primary" style={{
                                position: 'fixed',
                                bottom: 75,
                                right: 10,
                                fontSize: 12
                            }} onClick={() => this.goBack()}>
                                뒤로가기
                        </Fab>
                        </Tooltip>
                    )}

                    {
                        window.location.pathname.toLowerCase().startsWith('/display') ||
                        window.location.pathname.toLowerCase().startsWith('/signin') ||
                        window.location.pathname.toLowerCase().startsWith('/signup') ||
                        window.location.pathname.toLowerCase().startsWith('/findidpw') ||
                        window.location.pathname.toLowerCase().startsWith('/showcase')
                        ? (<div></div>) : (
                        <Tooltip title="로그아웃" aria-label="add">
                                <Fab color="secondary" style={{
                                    position: 'fixed',
                                    bottom: 10,
                                    right: 10,
                                    fontSize: 12
                                }} onClick={() => {
                                    document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });

                                    window.location.assign('/display/connected');
                                }}>
                                로그아웃
                        </Fab>
                        </Tooltip>
                    )}
                    
                </Container>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js